<template>
  <a-row>
    <a-form :form="form">
      <a-form-item label="用户名" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="用户名" v-decorator="[ 'account', {rules: [{ required: true, message: '请输入用户名！'}]} ]"/>
      </a-form-item>
      <a-form-item label="初始密码" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="密码" type="password" v-decorator="[ 'passwd', {rules: [{ required: true, message: '请输入密码！'}]} ]"/>
      </a-form-item>
      <a-form-item label="手机号" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="手机号" v-decorator="[ 'mobile', {rules: [{ required: true, message: '请输入手机号！'}]} ]"/>
      </a-form-item>
      <a-form-item style="text-align: center; margin-bottom: 12px;">
        <a-button type="primary" @click="editAgent">{{edit}}</a-button>
      </a-form-item>
    </a-form>
  </a-row>
</template>

<script>

export default {
  name: 'EditManager',
  data() {
    return {
      form: this.$form.createForm(this),
      type: '',
      edit: "",
      refresh: 0,
    }
  },
  props: {
    uid: {
      type: String,
      default: function () {
        return ""
      }
    }
  },
  watch: {
    uid: function(newvalue, oldvalue) {
      if (newvalue != "") {
        this.edit = "保存";
        let postdata = {
          task: "GET_AGENT_DETAIL",
          uid: this.uid
        }
        let that = this;
        that.post("manager", postdata)
          .then(function(data) {
            if (data.ret == 200) {
              that.form.setFieldsValue(
                data.data
              );
            }
          }).catch(function (e) {
        });
      } else {
        this.edit = "创建新代理";
      }
    }
  },
  methods: {
    editAgent: function () {
      let e = false;
      this.form.validateFields((err, values) => {
        if (err) {
          e = true;
          return;
        }
      });
      if (e) {
        return;
      }
      let item = this.form.domFields;
      let postdata = {};
      for (let key in item) {
        postdata[key] = this.form.getFieldValue(key);
      }
      if (this.uid != "") {
        postdata["task"] = "UPDATE_AGENT_DETAIL";
        postdata["uid"] = this.uid;
      } else {
        postdata["task"] = "ADD_AGENT";
      }
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success(that.edit + "成功");
            that.$emit("change", postdata["task"]);
          } else {
            that.$message.error("失败");
          }
        }).catch(function (e) {
          that.$message.error("失败");
      });
    }
  },
  created() {
    if (this.uid == "") {
      this.edit = "创建新代理商";
    } else {
      this.edit = "保存";
      let postdata = {
        task: "GET_AGENT_DETAIL",
        uid: this.uid
      }
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.form.setFieldsValue(
              data.data
            );
          }
        }).catch(function (e) {
      });
    }
  }
}
</script>

<style scoped>
</style>
